var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170.6 99.8",
    style: {
      enableBackground: "new 0 0 170.6 99.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:currentColor;}\n\t.st1{fill:currentColor;}\n\t.st2{fill:currentColor;stroke:currentColor;stroke-miterlimit:10;}\n\t.st3{fill:currentColor;stroke:currentColor;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.9,28.9c0,0,0-0.1,0-0.1c0.3-0.9,0.5-1.8,0.6-2.7c0.5-3.5,0-6.9-1.1-10.3c0-0.1-0.1-0.1-0.1-0.1 s-0.7,0.1-1,0.1c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0C94.1,20,94.7,24.3,93.9,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.8,15.7c-0.2,0.3-0.4,0.5-0.6,0.8c-0.1,0.1-0.1,0.1,0,0.2c0.5,1.3,0.8,2.6,1,3.9c0.4,2.6,0.3,5.1-0.1,7.7 c0,0.1,0,0.2,0,0.2C93.2,24.3,93.1,20,91.8,15.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129,48.6c-6.1,7.1-5.3,14.1-5.7,21c-2.5-0.9-3-3.2-4.1-5.2c-6.6-12.2-13.4-24.2-19.8-36.4 c-2.3-4.3-4.1-4.9-6.4-1.4c0.2-5.3-3.2-2.2-4.6-0.6C84,30.9,80,36.1,76.2,41.5c-1.7,2.5-3.4,5.7-6.2,5.6 c-5.4-0.1-8.7,2.9-11.7,6.2c-6.3,7-12.6,13.8-23.1,14.2c-1.9,0.1-3.9,1.4-5.4,2.6C19.6,79.1,9.3,88,0,99.7 c14.9,0,28.6-0.2,42.2,0.1c4.9,0.1,7.8-1.1,9.9-6.1c1.8-4.3,5.1-8.1,9.2-11.2c9.3-7.2,20.1-10.7,31.2-13.8 c10.6-3,12.7-8.7,6.7-18c-1.4-2.2-3.6-3.8-4.9-5.9c-3.1-5.1-7.7-10.2-2.2-16c-1.7,7.9,3.2,12.9,8.5,17.8c8.7,8,10.5,17,4,22.3 c-3.9,3.2-8,6.3-12.7,8.6c-6.6,3.3-14.8,9.7-22.6,21.9c7.8-4.6,19.6-10.2,34.8-12.6c32.1-5.1,57.5,7.6,66.5,12.6 C154.4,83.5,138.3,69.3,129,48.6z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "98.6,16.9 92.2,15.5 87.3,19.9 86.8,13.3 81,10.1 87.1,7.5 88.4,1.1 92.7,6.1 99.3,5.3 95.9,11  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7b49ccfb473bc51c008d395b735b3c71.svg";
export { ForwardRef as ReactComponent };